import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';
import { DraggableModal } from '../shared/draggable-modal/draggable-modal.class';

@Component({
  selector: 'app-notes-card',
  templateUrl: './notes-card.component.html',
  styleUrls: ['./notes-card.component.scss']
})
export class NotesCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() studentUserId;
  @Input() studentPartnerId;
  @Input() currentStudentName: string;
  itemFullView = false;
  clickedID;
  notes: Array<any>;
  flagNoteStatus = false;
  selectedNoteId;
  taskDetail = '';
  noteCategoryId = [];
  noteCategory = [];
  userId: any;
  colorJson = {};
  updatedBy;
  updatedDate;
  notesDataJson;
  currentNoteId = '0';
  searchFilter;
  bsModalRef: BsModalRef;
  modalOpenedSubscription: Subscription;
  refreshAutoNotes: Subscription;
  loader = false;

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private draggableModalService: DraggableModalService,
    private confirmModalService: ConfirmModalService,
    private _commonDataSharedService: CommonDataSharedService
  ) { }

  ngOnInit() {
    this.userId = this._commonAuthService.getUserId();
    this.modalOpenedSubscription = this.draggableModalService.modalOpened.subscribe((modal: DraggableModal) => {
      if (modal.id.indexOf('modal-note') > -1) {
        const getNotesSubscription = modal.modalRef.content.updateNotes.subscribe(() => {
          this.getNotesData();
          getNotesSubscription.unsubscribe();
        });
      }
    });
   this.refreshAutoNotes = this._commonDataSharedService.reloadAutoNotes.subscribe(() => {
      this.getNotesData();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentUserId && changes.studentUserId.currentValue && changes.studentPartnerId && changes.studentPartnerId.currentValue) {
      this.getNotesData();
      this.getNotesCategories();
    }
  }

  getNotesCategories() {
    const selectedType = {
      classTypeName: 'Note Class',
      partnerId: this.studentPartnerId
    };

    this._commonRequestResponseService.postWithHeader('admin/values/', selectedType, ['partnerId'])
      .subscribe(
        (noteCategoryData: any) => {
          this.noteCategory = noteCategoryData.items;
          this.getColorJson(this.noteCategory);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching note category');
        });
  }

  getColorJson(category) {
    for (let i = 0; i < category.length; i++) {
      this.colorJson[category[i].value] = category[i].other;
    }
  }

  deleteNotePop(noteObject) {
    this.selectedNoteId = noteObject.id;
    this.confirmModalService.open({
      ok: () => {
        this.deleteNote()
      },
      text: 'Are you sure you want to delete the selected Note?',
      labels: ['Yes', 'Cancel']
    });
  }

  deleteNote() {
    this.loader = true;
    const deleteNoteJson = {
      noteId: this.selectedNoteId,
      studentuserId: this.studentUserId,
      active: 0,
    };

    this._commonRequestResponseService.post('student/note/delete', deleteNoteJson)
      .subscribe(
        () => {
          this.loader = false;
          this.notificationService.show('success', 'Note deleted successfully');
          this.getNotesData();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while deleting Note');
        });
  }

  getNotesData() {
    const inputJson = {
      studentUserId: this.studentUserId,
      partnerId: this.studentPartnerId
    };
    this._commonRequestResponseService.postWithHeader('student/notes', inputJson, ['partnerId'])
      .subscribe(
        (notesDataJson: any) => {
          this._commonDataSharedService.loader.next(true);
          this.notesDataJson = notesDataJson.items;
        },
        () => {
          this.notesDataJson = [];
          this._commonDataSharedService.loader.next(true);
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  editNotesData(noteObject) {
    this.clearForm();
    this.currentNoteId = noteObject.id;
    this.noteCategoryId = noteObject.categories;
    this.taskDetail = noteObject.text;
    this.flagNoteStatus = noteObject.flag;
    this.updatedBy = noteObject.updatedBy;
    this.updatedDate = noteObject.updated;
    if (this.noteCategoryId) {
      for (let i = 0; i < this.noteCategoryId.length; i++) {
        for (let j = 0; j < this.noteCategory.length; j++) {
          if (parseInt(this.noteCategory[j].value, 10) === parseInt(this.noteCategoryId[i], 10)) {
            this.noteCategory[j].checked = true;
          }
        }
      }
    }
    this.showNoteModal(false);
  }

  clearForm() {
    this.currentNoteId = '0';
    this.taskDetail = '';
    this.updatedBy = '';
    this.updatedDate = '';
    this.flagNoteStatus = false;
    for (let i = 0; i < this.noteCategory.length; i++) {
      this.noteCategory[i].checked = false;
    }
  }

  showSelectedNote(note) {
    this.itemFullView = this.clickedID !== note.id ? true : !this.itemFullView;
    this.clickedID = note.id;
    note.showFull = !note.showFull;
  }

  showNoteModal(isNew = true) {
    const baseId = `modal-note`;
    const id = `${baseId}-${this.studentUserId}-${(isNew ? 'add' : 'update')}-${this.studentUserId}`;
    this.draggableModalService.show({
      baseId,
      id,
      trayTitle: `${(isNew ? 'Add' : 'Update')} note for ${this.currentStudentName}`,
      initialState: {
        modalId: id,
        studentName: this.currentStudentName,
        currentNoteId: this.currentNoteId,
        noteCategory: this.noteCategory.slice().map(a => ({ ...a })),
        noteCategoryId: this.noteCategoryId ? this.noteCategoryId.slice() : '',
        updatedBy: this.updatedBy,
        updatedDate: this.updatedDate,
        taskDetail: this.taskDetail,
        flagNoteStatus: this.flagNoteStatus,
        studentUserId: this.studentUserId,
        updatedByUserId: this.userId
      }
    });
  }

  ngOnDestroy() {
    this.modalOpenedSubscription.unsubscribe();
    this.refreshAutoNotes.unsubscribe();
  }
}
